// extracted by mini-css-extract-plugin
export var buyLink = "styles-module__buyLink___b34sO";
export var container = "styles-module__container___bVL3d";
export var featureCheckIcon = "styles-module__featureCheckIcon___hNtKf";
export var featureRow = "styles-module__featureRow___f50g1";
export var featureRowCell = "styles-module__featureRowCell___CweaN";
export var featureRowFree = "styles-module__featureRowFree___X_9HX";
export var featureRowPro = "styles-module__featureRowPro___G0BRj";
export var featureRowText = "styles-module__featureRowText___JfhPJ";
export var featureRowTint = "styles-module__featureRowTint___j7A3c";
export var featuresContainer = "styles-module__featuresContainer___nUY4x";
export var headerRow = "styles-module__headerRow___jZJG_";
export var headerRowFeature = "styles-module__headerRowFeature___hTcPQ";
export var headerRowFreePro = "styles-module__headerRowFreePro___SIxU_";
export var headerRowProIcon = "styles-module__headerRowProIcon___w9u5J";
export var logoProImage = "styles-module__logoProImage___EEXHL";
export var tableHeader = "styles-module__tableHeader___ip8ot";
export var title = "styles-module__title___wLwpM";
export var upperContainer = "styles-module__upperContainer___W8tFz";